/**
 *
 * @param requestType
 * @returns {Promise<{}>}
 */
async function syncWithOnlineServer(requestType) {
  let tableObj = {};
  /**
   * * 1 - Instancio la base de datos offline
   */
  var swIdb = await new Dexie('la-segunda-offline-db');

  /**
   * * 2 - abro la base de datos para poder cmenzar a trabajar
   */
  await swIdb.open().catch(function (err) {
    console.error('Failed to open db: ' + (err.stack || err));
  });

  /**
   * * 3 - Creo una coleccion a partir de la tabla de examenesPorEnviar
   * * tambien ya me combiene traer de una ves el accestoken de la tabla de current user
   */
  let elementsInTable;
  let currentUserAccessToken = await (await swIdb.table("currentUser").get(1)).accessToken;
  let examenesPorEnviarCollection = await swIdb.table("examenesPorEnviar").toCollection();
  let examenesPorEnviarTable = await swIdb.table("examenesPorEnviar");

  let intervaloDe5Segundos = setInterval(async () => {
    let status = {};
    await examenesPorEnviarCollection.count(q => elementsInTable = q);
    // for (let index = 0; index < await elementsInTable; index++) {
    if (requestType === 'save-examen') {
      status = await synchronizeExamenWithOnlineServer( examenesPorEnviarCollection, currentUserAccessToken, examenesPorEnviarTable);
    } else if (requestType === 'close-examen') {
      status = await synchronizeExamenWithOnlineServer( examenesPorEnviarCollection, currentUserAccessToken, examenesPorEnviarTable);    
    }

    if (await status.isSuccesses) {
      await examenesPorEnviarTable.delete(status.id);
    }

    if (elementsInTable === 0) {
      clearInterval(intervaloDe5Segundos);
    }
    // }
  }, 10000);

  return tableObj;
}

/**
 * * CERRAR EXAMEN
 * @param {*} examenesPorEnviarCollection
 * @param {*} currentUserAccessToken
 */
async function synchronizeExamenWithOnlineServer(examenesPorEnviarCollection, currentUserAccessToken, examenesPorEnviarTable) {

  /**
   * * 4 - Busco el primer elemento de la tabla / collecction,
   * *     y tomo los datos que necesito para hacer la llamada
   */
  examenesPorEnviarCollection.first(async (item) => {    const method = (item.fueCerrado)? 'PUT' : 'POST';
    item.examenDataToSend.cargadoOffline = true;

    tableObj = {
      isSuccesses: false,
      id: item.id,
      url: item.onOnlineSendTo,
      fueCerrado: item.fueCerrado,
      data: JSON.stringify(item.examenDataToSend)
    };

    /**
     * ? TODO: aca me tengo que guardar el id para una vez completada la llamada a la api
     * ?       con éxito lo pueda usar luego para eliminarlo de la tabla
     * ? en el online send to tendría que en el mismo momento de guardar la data to send guardar la URL
     * ? para ese fin y para el del registro creo que seria bueno centralizar todas las llamadas
     * ? a todas las apis en un solo servicio que reciba url datos y configuración que seria
     */

    console.log(tableObj)

    await fetch(item.onOnlineSendTo, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${currentUserAccessToken}`
      },
      body: JSON.stringify(item.examenDataToSend)
    })
      .then(async () => {
        tableObj.isSuccesses = true;
        Promise.resolve()
      })
      .catch(async (err) => {

        await item.errorOnTryToSendBySW.push({
          timestamp: new Date().getTime(),
          error: err
        });
        examenesPorEnviarTable.put(item, item.id)
          .then((e) => console.log('ok', e))
          .catch((e) => console.log('ERROR', e))
        console.error(err);
        Promise.reject()
      })

  });
  return tableObj;
}
